import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADES]: {
		url:'/company/:companyId/done_works/:doneWorkId/brigade/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/brigade/:brigadeId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/brigade/:brigadeId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE]: {
		url: '/company/:companyId/done_works/:doneWorkId/brigade/:brigadeId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].CREATE_DONE_WORKS_BRIGADE]: {
		url:'/company/:companyId/done_works/:doneWorkId/brigade/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PATCH_DONE_WORKS_BRIGADE]: {
		url: '/company/:companyId/done_works/:doneWorkId/brigade/:brigadeId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PUT_DONE_WORKS_BRIGADE]: {
		url: '/company/:companyId/done_works/:doneWorkId/brigade/:brigadeId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].DELETE_DONE_WORKS_BRIGADE]: {
		url: '/company/:companyId/done_works/:doneWorkId/brigade/:brigadeId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}